import React, { Component } from 'react';
import './styles.scss';
import { connect } from 'react-redux';

import {
    getNotification,
    ACTIONS_NOTIFICATION
} from './../../../actions/notification';

class LeftMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itemALls: [
                { title: 'ダッシュボード', url: '/dashboard', icon: '/img/action/dashboard_24px.svg', active: true, role:-1 },
                { title: 'LIVE', url: '/live', icon: '/img/action/live_24px.svg', active: false, role:-1 },
                { title: 'リーダーボード', url: '/leader-board', icon: '/img/action/leaderboard_24px.svg', active: false, role:-1 },
                { title: 'My Topics', url: '/my-topic', icon: '/img/action/whatshot_24px.svg', active: false, role:-1 },
                { title: 'Playlog Search', url: '/playlog-search', icon: '/img/action/playlog_search_24px.svg', active: false, role:-1 },
                { title: 'RECOMMEND', url: '/recommend', icon: '/img/action/recommend_24px.svg', active: false, role:-1 },
                { title: '詳細検索', url: '/detailed-search', icon: '/img/action/research_24px.svg', active: false, role:-1},
                { title: '顧客', url: '/admin-company', icon: '/img/action/staff_24px.svg', active: false, urlChild: 'admin-list-user', role:1 },
                { title: 'スタッフ', url: '/admin-user', icon: '/img/action/group_24px.svg', active: false, role:1 },
                { title: '納品', url: '/admin-delivery', icon: '/img/action/delivery_24px.svg', active: false, role:3 },
                { title: '配信', url: '/admin-news', icon: '/img/action/mail_24px.svg', active: false, role:1 },
                { title: '納品', url: '/delivery', icon: '/img/action/delivery_24px.svg', active: false, notification: true, role:0 },
                { title: 'マニュアル', key: 'blog', url: 'https://wiki.ashirobo.jp/wiki/', icon: '/img/action/blog_24px.svg', active: false, role:-1, external:true },
            ],
            items: []
        }
    }

    onActiveNav = (itemAll, item) => {
        const { history } = this.props;
        itemAll.forEach((i, k) => {
            i.active = false;
        })
        if (item.url) {
            item.active = true;
            if (item.external || false) {
                window.open(item.url, '_blank');
            } else {
                history.push(`${item.url}`);
            }
        }
    }

    findItemActive = (it) => {
        this.state.itemALls.forEach(obj => {
            if (it.includes(obj.url)) {
                obj.active = true;
            } else {
                obj.active = false;
                if (it.includes(obj.urlChild)) {
                    obj.active = true;
                }

            }
        });
    }

    UNSAFE_componentWillMount() {
        this.findItemActive(this.props.location.pathname);
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        this.findItemActive(nextProps.location.pathname);

        if (nextProps.statusNotification == ACTIONS_NOTIFICATION.GET_NOTIFICATION_SUCCESS) {
            this.setState({
                notification: nextProps.responseNotification.delivery
            })
        }
        const menus = JSON.parse(localStorage.getItem('MENUS') || "[]");
        this.setState({
            items: this.state.itemALls.filter((o) => {
                return menus.includes(o.url.slice(1)) || (o.key && menus.includes(o.key))
            })
        })

    }

    render() {
        return (
            <div className="left-menu">
                {this.props.location.pathname === '/login'
                    || this.props.location.pathname === '/' ? '' :
                    <div className="left-menus">
                        <div className="content">
                            <img src="/img/action/home.svg" alt="" />
                        </div>

                        {this.state.items.map((value, key) => {
                            return (
                                <div key={key.toString()} className="content"
                                    onClick={() => this.onActiveNav(this.state.items, value)}>
                                    <div className={`item ${value.notification ? 'notification' : ''} ${value.active === true ? 'active' : ''}`}>
                                        <div className="icon">
                                            <img src={value.icon} alt="" />
                                            {value.notification && this.state.notification ?
                                                <div className="ic-notification">{this.state.notification}</div> : ''}
                                        </div>
                                        <p className="item-name">{value.title}</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>}
            </div>
        )
    }
}

const mapStateToProps = ({ notification }) => {
    return {
        responseNotification: notification.response,
        statusNotification: notification.status,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getNotification: () => {
            dispatch(getNotification())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(LeftMenu);
